// extracted by mini-css-extract-plugin
module.exports = {"accent01":"#f1c40f","accent02":"#e74c3c","accent03":"#444","body01":"#444"};